/**
 * Redirect cart button to cart page if cart type is page
 */
document.addEventListener("DOMContentLoaded", (event) => {
    let cartBtn = document.querySelector('.js-drawer-open-cart');
    if (cartBtn) {
        cartBtn.addEventListener('click', () => {
            let thisHref = cartBtn.getAttribute('href');
            if (window.theme.settings.cartType === 'page') {
                window.location.href = thisHref;
            }
        })
    }
});

document.addEventListener("DOMContentLoaded", (event) => {
    let intervalTime = 100;
    let totalTime = 5000;
    let elapsedTime = 0;
    const interval = setInterval(() => {
        if (document.querySelector('[data-forms-id="forms-root-195917"] form-embed')) {
            const formEmbed = document.querySelector('[data-forms-id="forms-root-195917"] form-embed');
            const customFormHeadings = formEmbed.shadowRoot.querySelector('._formHeader_1ll8d_19');
            const customFormInput = formEmbed.shadowRoot.querySelector('#email');
            const customFormLabel = formEmbed.shadowRoot.querySelector('#label-email');
            const customFormButton = formEmbed.shadowRoot.querySelector('button');
            if (customFormHeadings) {
                customFormHeadings.remove();
            }

            const customFormForm = formEmbed.shadowRoot.querySelector('form');
            if (customFormForm) {
                customFormForm.style.paddingTop = "2px";
                customFormInput.style.backgroundColor = 'transparent';
                customFormInput.style.boxShadow = 'none';
                customFormInput.style.borderBottom = '2px solid';
                customFormInput.style.borderRadius = '0';
                customFormInput.style.paddingLeft = '0';
                customFormLabel.style.left = '0';
                customFormLabel.style.color = '#000000';
                customFormButton.borderRadius - '0';
                customFormButton.style.backgroundColor = 'transparent';
                customFormButton.style.boxShadow = 'none';
                customFormButton.style.paddingRight = '0';
                customFormButton.style.color = '#000000';
                customFormButton.style.position = 'absolute';
                customFormButton.style.top = '0';
                customFormButton.style.right = '5px';
            }

            const footerParagraph = document.querySelector('.footer__collapsible p');
            if (footerParagraph) {
                footerParagraph.insertAdjacentElement('afterend', formEmbed);
            }

            clearInterval(interval);
        } else {
            elapsedTime += intervalTime;
            if (elapsedTime >= totalTime) {
                clearInterval(interval);
            }
        }
    }, intervalTime);
});
